import { render, staticRenderFns } from "./JobAccountFormStepBranchInformation.vue?vue&type=template&id=23c65034"
import script from "./JobAccountFormStepBranchInformation.vue?vue&type=script&lang=js"
export * from "./JobAccountFormStepBranchInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports